export const alertWindowAnimations = {
  enter: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.1,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.1,
    },
  },
};

export const childAnimations = {
  exit: {
    x: -10,
    opacity: 0,
    transition: {
      duration: 0.1,
    },
  },
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.1,
    },
  },
};
